import { useMutation } from '@apollo/client';
import { captureException } from '@sentry/react';

import { Severity, useAlert } from '~/context/AlertProvider';
import { CREATE_CUSTOMER_SUPPORT_REQUEST } from '~/graphql/videos';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { Mutation, MutationCreateCustomerSupportRequestArgs } from '~/types';

const useReport = (relatableEntityType) => {
  const { t, i18n } = useTenantTranslation();
  const { showAlert } = useAlert();

  const [submit, { loading }] = useMutation<
    Pick<Mutation, 'createCustomerSupportRequest'>,
    MutationCreateCustomerSupportRequestArgs
  >(CREATE_CUSTOMER_SUPPORT_REQUEST, {
    onCompleted: (data) => {
      if (data.createCustomerSupportRequest === 1) {
        showAlert({ message: t('page.video.issueSuccessfullyReported') });
        return;
      }

      captureException(new Error(`Unable to send report`));
      showAlert({ message: t('error.errorHappened'), severity: Severity.Error });
    },
  });

  return {
    submit: ({ message, requestTypeId, relatableEntityId }) =>
      submit({
        variables: {
          input: {
            message,
            request_type_id: requestTypeId,
            lang_code: i18n.language,
            relatable_entity_id: relatableEntityId,
            relatable_entity_type: relatableEntityType,
          },
        },
      }),
    loading,
  };
};

export default useReport;
